// services/EditorService.js
import { newServer } from 'constants/constants';
import axios from 'axios';

const BASE_URL = `${newServer}` + 'policies';

export const EditorService = {
  getTermsAndPrivacy: () => {
    return axios.get(`${BASE_URL}/get`);
  },

  updateTermPrivacy: (type: string, content: any) => {
    //convertit content a HTML
    const htmlContent = content;
    return axios.put(`${BASE_URL}/update/${type}`, { content: htmlContent });
  },

  getHtmlContent: (url: string) => {
    return axios.get(url, {
      headers: {
        Accept: 'text/html,text/plain,*/*',
      },
      responseType: 'text',
      withCredentials: false,
    });
  },
};
